/* istanbul ignore file */

export enum BlockModuleType {
  BODY_TEXT = 'bodytext',
  INLINE = 'inline',
  MODULE = 'module',
}
